import debounce from 'lodash.debounce';
import * as bootstrap from 'bootstrap';

class NavScroll {
    constructor(element, config) {
        const defaultConfig = {
            swipeLength: 150,
            swipeTime: 200,
            root: 'window',
        }
        this.config = Object.assign({}, defaultConfig, config);
        this.element = element;
        this.swipeState = {
            swipeMoving: false,
            swipeDirection: '',
        }
        this.swiping = false;

        this._initDomReferences();
        this._init();
        this.reloadNav = this.reloadNav.bind(this);
        window.addEventListener('resize', debounce(this.reloadNav, 250));
    }

    _initDomReferences() {
        this.swipeNav = this.element.querySelector('.nav-scroll-container');
        this.swipeNavContent = this.swipeNav.querySelector('.nav');
        this.swipeNavItemDropdown = Array.from(this.swipeNavContent.querySelectorAll('.nav-item .dropdown'));
        this.swipeBtnLeft = this.element.querySelector('.nav-scroll-btn-left');
        this.swipeBtnRight = this.element.querySelector('.nav-scroll-btn-right');
        this.detachedDropdownMenu = null;
        this.detachedDropdownHost = null;
    }

    _init() {
        if(this.element.classList.contains('nav-scroll-init')){
            return false;
        }

        if (this.swipeNavItemDropdown.length) {
            this.swipeNavItemDropdown.forEach((dropdown) => {
                dropdown.addEventListener('show.bs.dropdown', (event) => {
                    const menu = event.target.querySelector('.dropdown-menu');
                    const toggle = event.target.querySelector('[data-bs-toggle="dropdown"], [data-toggle="dropdown"]');

                    if (!menu || !toggle) {
                        return;
                    }

                    const toggleRect = toggle.getBoundingClientRect();
                    const menuWidth = menu.offsetWidth;

                    menu.style.top = `${toggleRect.top + window.scrollY + toggle.offsetHeight}px`;
                    menu.style.left = `${toggleRect.left + window.scrollX - menuWidth + toggle.offsetWidth}px`;
                    menu.style.width = `${menuWidth}px`;
                    menu.style.minWidth = `${menuWidth}px`;

                    document.body.appendChild(menu);
                    this.detachedDropdownMenu = menu;
                    this.detachedDropdownHost = event.target;
                });

                dropdown.addEventListener('hide.bs.dropdown', (event) => {
                    this.restoreDetachedDropdown(event.target);
                });
            });
        }

        if (this.swipeBtnRight) {
            this.swipeBtnRight.addEventListener('click', (e) => {
                this.swipeNavContent.querySelectorAll('li').forEach(element => {
                    const elementRect = element.getBoundingClientRect();
                    if ( elementRect.left + element.offsetWidth > this.element.width ) {
                        this.config.swipeLength = (elementRect.left + element.offsetWidth + 20) - this.element.width;
                        return false;
                    }
                })
                this._swipeTo('right', 'left', this.config.swipeLength);
            })
        }

        if (this.swipeBtnLeft) {
            this.swipeBtnLeft.addEventListener('click', (e) => {
                this.swipeNavContent.querySelectorAll('li').forEach(element => {
                    const elementRect = element.getBoundingClientRect();
                    if (elementRect.left + element.offsetWidth - 20 > 0 && elementRect.left + element.offsetWidth - 20 < element.offsetWidth) {
                        this.config.swipeLength = -(elementRect.left - 40);
                        return false;
                    }
                })
                this._swipeTo('left', 'right', -this.config.swipeLength);
            })
        }

        this.swipeNav.addEventListener('scroll', () => {
            if (!this.swiping) {
                window.requestAnimationFrame(() => {
                    this.element.setAttribute('data-overflowing', this._swipeDirection());
                    this.swiping = false;
                });
            }

            this.swiping = true;

            if (this.swipeNavItemDropdown.length && this.detachedDropdownMenu && this.detachedDropdownHost) {
                const toggle = this.detachedDropdownHost.querySelector('[data-bs-toggle="dropdown"], [data-toggle="dropdown"]');

                if (toggle) {
                    bootstrap.Dropdown.getOrCreateInstance(toggle).hide();
                } else {
                    this.restoreDetachedDropdown(this.detachedDropdownHost);
                }
            }
        })

        this.element.setAttribute('data-overflowing', this._swipeDirection());
        this.showActiveItem();

        this.element.classList.add('nav-scroll-init');
    }

    _swipeDirection() {
        const navSizeRect = this.swipeNav.getBoundingClientRect();
        const navSizeRight = Math.floor(navSizeRect.right);
        const navSizeLeft = Math.floor(navSizeRect.left);

        const contentSizeRect = this.swipeNavContent.getBoundingClientRect();
        const contentSizeRight = Math.floor(contentSizeRect.right) -1;
        const contentSizeLeft = Math.floor(contentSizeRect.left);

        if (navSizeLeft > contentSizeLeft && navSizeRight < contentSizeRight) {
            return 'both';
        } else if (contentSizeLeft < navSizeLeft) {
            return 'left';
        } else if (contentSizeRight > navSizeRight) {
            return 'right';
        } else {
            return 'none';
        }
    }

    _swipeTo(direction, newDirection, length) {
        if (this.swipeState.swipeMoving === true) {
            return;
        }
        if (this._swipeDirection() === direction || this._swipeDirection() === 'both') {
            this.swipeState.swipeMoving = true;

            this._animateScroll(this.swipeNav, length, this.config.swipeTime, () => {
                this.swipeState.swipeDirection = '';
                this.swipeState.swipeMoving = false;
                this.config.swipeTime = 200;
            })

            this.swipeState.swipeDirection = newDirection;
        }
    }

    _animateScroll(element, length, swipeTime, callback) {
        const currentScrollLeft = element.scrollLeft;
        const targetScrollLeft = currentScrollLeft + length;

        element.scrollTo({
            left: targetScrollLeft,
            behavior: 'smooth'
        });

        setTimeout(() => {
            if (callback && typeof callback === 'function') {
                callback.call(this);
            }
        }, swipeTime);
    }

    showActiveItem() {
        this.activeNavItem = this.swipeNavContent.querySelector('.active');
        if (this.activeNavItem && this.swipeNav) {
            const activeNavItemRect = this.activeNavItem.getBoundingClientRect();
            const swipeNavRect = this.swipeNav.getBoundingClientRect();

            const activeNavItemPos = activeNavItemRect.right - swipeNavRect.left;
            if (activeNavItemPos > this.swipeNav.offsetWidth - 50) {
                this.config.swipeTime = 0;
                this._swipeTo('right', 'left', (activeNavItemPos - this.swipeNav.offsetWidth) + 40);
            } else if (activeNavItemRect.left - swipeNavRect.left < 60) {
                this.config.swipeTime = 0;
                this._swipeTo('left', 'right', (activeNavItemPos - this.activeNavItem.offsetWidth) - 40);
            }
        }
    }

    reloadNav() {
        this.element.setAttribute('data-overflowing', this._swipeDirection());
        this.showActiveItem();
        if (this.swipeNavItemDropdown.length) {
            this.swipeNavItemDropdown.forEach((dropdown) => {
                const toggle = dropdown.querySelector('[data-bs-toggle="dropdown"], [data-toggle="dropdown"]');
                if (toggle) {
                    bootstrap.Dropdown.getOrCreateInstance(toggle).hide();
                }
            });
        }
    }

    restoreDetachedDropdown(dropdown) {
        if (!this.detachedDropdownMenu || !dropdown || this.detachedDropdownHost !== dropdown) {
            return;
        }

        dropdown.append(this.detachedDropdownMenu);
        this.detachedDropdownMenu.removeAttribute('style');
        this.detachedDropdownMenu = null;
        this.detachedDropdownHost = null;
    }
}

const navScroll = function(elements, config) {
    if(elements instanceof NodeList) {
        elements.forEach(element => {
            return new NavScroll(element, config);
        })
    } else {
        return new NavScroll(elements, config)
    }
}

export default navScroll;
